module.exports = __webpack_public_path__ + "static/media/manta_ray_thumb_even.3dd7d6a9.jpg";